import React from "react";
import {mapResourceTypeToIcon, parseUserName} from "./NoteShareWith";

const NoteSharedWith = ({ note_tags }) => {
  const label = (tag) => {
    if (tag.recipient_type === "User") {
      return parseUserName(tag);
    }
    return tag.name;
  }

  return <div>
    <small className="text-secondary mr-1">Shared With:</small>
    {note_tags.map((tag) => {
      return <small className="text-secondary mr-1">
        <i className={`fas fa-${mapResourceTypeToIcon(tag.recipient_type)} mr-1`}/>
        {label(tag)}
      </small>
    })}
  </div>
}

export default NoteSharedWith;
